module.exports = __webpack_public_path__ + "img/bell.d5a17e72.svg";